
import { queryClient } from '../state/queryClient';

import { axios_email_modifymailread , axios_email_modifymailfavori} from '../axios/axios_email';


export const modifyMailRead =async  (type,id)=>{
    await axios_email_modifymailread(id) ; 
    type==='user' && queryClient.invalidateQueries({ queryKey: ['listmails']}) ;
    type==='gestion' && queryClient.invalidateQueries({ queryKey: ['listgestionmails']}) ;


}



export const modifyMailFavori = (choice,type, id,favori)=>{
  axios_email_modifymailfavori({id,favori}) ; 
  const typequeryemails = type==='user'?'listmails':'listgestionmails';
  const typeemails = choice=== 'selectemailsortants'?'emailssortants':'emailsentrants';

  const queryclientgetdata = queryClient.getQueryData([typequeryemails]) ;
  const otheremails = queryclientgetdata?.[typeemails]?.filter(x=>x.id!==id);
  const emailchange = queryclientgetdata?.[typeemails]?.filter(x=>x.id===id)[0];
  const newmails_typeemails ={[typeemails]:[...otheremails,{...emailchange, 'favori':favori}]} ;
  const newquerydata = {...queryclientgetdata, ...newmails_typeemails}

  queryClient.setQueryData([typequeryemails],newquerydata);


}